import { EditFilled } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { Link, useParams } from "react-router-dom";

type Props = {
  page: number;
  pageSize: number;
};

const MainWebsitesGeneralEdit = (props: Props) => {
  const { page, pageSize } = props;
  const { id } = useParams();

  return (
    <div className="flex flex-col gap-3">
      <Link
        to={`/main-websites/edit-title/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Title
        </Button>
      </Link>
      <Link
        to={`/main-websites/edit-description/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Description
        </Button>
      </Link>
      <Link
        to={`/main-websites/edit-keywords/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Keywords
        </Button>
      </Link>
      <Link
        to={`/main-websites/edit-image/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Image
        </Button>
      </Link>{" "}
      <Link
        to={`/main-websites/manage-categories/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Manage Categories
        </Button>
      </Link>{" "}
      <Link
        to={`/main-websites/manage-homepage/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Manage Homepage
        </Button>
      </Link>{" "}
    </div>
  );
};

export default MainWebsitesGeneralEdit;
